import * as qs from 'qs';
import { useMemo } from 'react';
import { useLocation } from 'react-router';

import { useCurrentUserContext } from '#src/contexts/currentUser/index.ts';
import { nullAddress } from '#src/lib/ethereum.ts';

export const useNeedsCreateEthWallet = () => {
  const { currentUser } = useCurrentUserContext();
  const location = useLocation();

  const { reset_password_token } = useMemo(
    () => qs.parse(location.search.slice(1)),
    [location.search]
  );

  const needsCreateEthWallet =
    currentUser?.email &&
    (!currentUser.wallet?.ethereumAddress ||
      currentUser.wallet?.ethereumAddress === nullAddress ||
      (!currentUser.starkKey &&
        currentUser.sorarePrivateKey &&
        !reset_password_token));

  return needsCreateEthWallet;
};
